import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import { COLORS } from '@client/shared/js/Colors';
import playIcon from '@client/shared/styles/assets/play/play-icon-white.svg';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './sectionTitle.scss';

class SectionTitle extends PureComponent {
  getTitleStyleClassname() {
    return classNames({
      [`${themeStyles.headerLarge} ${styles.title}`]: !this.props
        .classNameTitle,
      [this.props.classNameTitle]: this.props.classNameTitle,
    });
  }

  render() {
    const {
      className,
      title,
      linkText,
      linkTextNotActive,
      onLinkClick,
      titleColor = COLORS.colorBrandYellow,
      linkColor,
      icon,
    } = this.props;
    const inlineStyle = {
      titleStyle: {
        color: titleColor,
      },
      linkStyle: {
        color: linkColor,
      },
    };
    return (
      <div
        className={
          className
            ? `${styles.sectionTitle} ${className}`
            : styles.sectionTitle
        }
      >
        <div
          style={inlineStyle.titleStyle}
          className={`${themeStyles.headerLarge} ${styles.titleContainer}`}
        >
          <div
            style={{ backgroundColor: titleColor }}
            className={styles.rectangle}
          />
          <p className={this.getTitleStyleClassname()}>{title}</p>
        </div>
        <div
          style={inlineStyle.linkStyle}
          onClick={onLinkClick}
          className={
            linkTextNotActive
              ? `${styles.hidden}`
              : `${styles.linkTextContainer}`
          }
        >
          <p className={`${styles.linkText} ${themeStyles.titleSmall}`}>
            {linkText}
          </p>
          <img className={styles.playIcon} src={icon ? icon : playIcon} />
        </div>
      </div>
    );
  }
}

SectionTitle.propTypes = {
  className: PropTypes.string,
  classNameTitle: PropTypes.string,
  title: PropTypes.string,
  linkText: PropTypes.string,
  onLinkClick: PropTypes.func,
  linkColor: PropTypes.string,
  titleColor: PropTypes.string,
  icon: PropTypes.string,
  linkTextNotActive: PropTypes.bool,
};

export default SectionTitle;
